"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildRuleRefined = void 0;
const buildRuleRefined = (rule) => ({
    ID: rule.ID,
    metadata: {
        created: rule.metadata.created,
        updated: rule.metadata.updated,
    },
    access: rule.access,
    criteria: rule.criteria,
    endDate: rule.endDate,
    status: rule.status,
    tag: rule.tag,
});
exports.buildRuleRefined = buildRuleRefined;
//# sourceMappingURL=RuleRefined.js.map